export var RequestType;
(function (RequestType) {
    RequestType[RequestType["Url"] = 0] = "Url";
    RequestType[RequestType["Ping"] = 1] = "Ping";
    RequestType[RequestType["Html"] = 2] = "Html";
    RequestType[RequestType["Merge"] = 3] = "Merge";
    RequestType[RequestType["Office"] = 4] = "Office";
    RequestType[RequestType["Markdown"] = 5] = "Markdown";
    RequestType[RequestType["Undefined"] = 6] = "Undefined";
})(RequestType || (RequestType = {}));
